import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VueLazyload from 'vue-lazyload'
import iView from 'iview'
import 'common/js/axiosset'
import 'iview/dist/styles/iview.css'
import 'common/stylus/index.styl'
import 'common/fonts/iconfont.css'
import 'common/fonts/iconfont1.css'
import confirmBox from 'base/confirm'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import breadcrumbs from 'base/breadcrumb/breadcrumbs'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(iView)
Vue.use(VueLazyload, {
  preLoad: 2, // 预加载的屏幕宽高比
  observer: true, // 当指定元素进入页面时，自动触发函数 azyload 默认的触发方式是当页面滚动时，遍历全部元素，查看元素是否在视图内，从而加载图片。因此，当元素特别多时，非常消耗性能。采用 observer 则能避免这个问题，很好地提高性能。-- 兼容性一般， IE兼容11
  loading: require('@/assets/avatar.png'),
  error: require('@/assets/avatar.png'),
  attempt: 10
})
/* eslint-disable */
String.prototype.xbTrim = function () {
  return this.replace(/^\s+|\s+$/g, '')
}
/* 全局方法 未初始化调用时才会初始化 */
Vue.prototype.$confirm = confirmBox

Vue.prototype.$loadImg = function (value) {
  if (value == "" || value == undefined || value == null) {
    return require('@/assets/avatar.png')
  }
  return value
}


Vue.prototype.$remarkFormater = function (value) {
  const str = value.replace(/\n/g, '<br>')
  var strRegex = '((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
  // eslint-disable-next-line no-tabs
  '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' + // ftp的user@  可有可无
  // eslint-disable-next-line no-tabs
  '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
  // eslint-disable-next-line no-tabs
  '|' + // 允许IP和DOMAIN（域名）
  '(localhost)|' +
  // eslint-disable-next-line no-tabs
  '([\\w_!~*\'()-]+\\.)*' + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
  // eslint-disable-next-line no-tabs
  '\\w+\\.' + // 一级域名 -英文或数字  加上.
  // eslint-disable-next-line no-tabs
  '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
  // eslint-disable-next-line no-tabs
  '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
  // eslint-disable-next-line no-tabs
  // '((/?)|' + // url无参数结尾 - 斜杆或这没有
  // eslint-disable-next-line no-tabs
  '((/[\\w_!~ *\'()\\.;?:@&=+$,%#-]+)+/?)?'// 请求参数结尾- 英文或数字和[]内的各种字符
  var reg = new RegExp(strRegex, 'g')// i不区分大小写 g 全局搜索
  return str.replace(reg, function (str1, str2) {
    // console.log(str1, str2)
    let link = (str2 == '' || str2 == null) ? 'http://' + str1 : str1
    return `<a href="${link}" style="color: blue;text-decoration: underline;" target="_blank">${str1}</a>`
  })
}
Vue.prototype.$scoreColor = function (value) {
  if (value < 0) {
    // return 'violation-score-red'
    return 'violation-score'
  }
  if (value > 0) {
    // return 'violation-score'
    return 'violation-score-red'
  }
  return ''
}
/// 数字是正数 大于 0 显示 + 
Vue.filter('numberPositive', function (value = '0') {
  value = parseFloat(value)
  if (value > 0) {
    return '+' + value
  } else {
    return value
  }
})
/* 全局组件 初始化完成 */
// Vue.component('breadcrumbs', breadcrumbs)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js